import React, { useState } from "react";
import "./styles.css";
import HtmlCalendarMonth from "./_30_html_calendar_month.js";
import CalendarYear from "./_12_calendar_year.js";
import TopHeader from "./nav_top.js";
import MaxQtyCompare from "./_6_max_intraday_compare.js";
import IndexCompareChart from "./_51_index_compare_chart.js";
import DetailsPage from "./_pg_details.js";
import { useTagFilter } from "./TagFilterContext.js";
const MODULE_NAME = "Gains-Loss pg";

function GradientSeparator() {
    return (
        <div
            style={{
                height: 8,
                width: "100%",
                background: "linear-gradient(90deg, #0a2342 0%, #CCC 100%)",
                margin: "24px 0"
            }}
        />
    );
}

function isDesktop() {
    return typeof window !== "undefined" && window.innerWidth > 700;
}

// FIX: Accept screen and setScreen as props from App.js
export default function TodayPLPage({ screen: appScreen, setScreen: appSetScreen, ...otherProps }) {
    const storedId = sessionStorage.getItem("user_id");
    const latestDate = sessionStorage.getItem("latest_date");

    let formatedlatestDate = "";
    if (latestDate) {
        const [year, month, day] = latestDate.split("-");
        const d = new Date(Number(year), Number(month) - 1, Number(day));
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        const yy = String(d.getFullYear()).slice(-2);
        formatedlatestDate = `${mm}-${dd}-${yy}`;
    }

    const userId = storedId && !isNaN(Number(storedId)) ? Number(storedId) : 1;

    const [activeDate, setActiveDate] = useState(null);
    // FIX: Use App.js screen state, not local state
    const [refreshKey, setRefreshKey] = useState(0);

    // FIX: Use the screen and setScreen from App.js props
    const screen = appScreen || "compare_pg";
    const setScreen = appSetScreen || (() => console.warn("setScreen not provided"));
    const { globalTagFilter } = useTagFilter();

    function handleDateChange(newDate) {
        setActiveDate(newDate);
    }

    // FIX: This should call the App.js setScreen function
    const handleNavigate = (targetScreen, date) => {
        console.log("🎯 today_pg_PL handleNavigate:", targetScreen, date);
        console.log("🎯 Current screen before navigation:", screen);
        console.log("🎯 setScreen function available:", !!setScreen);
        
        if (targetScreen === "details_pg") {
            sessionStorage.setItem("navigationDate", date);
        }
        
        // FIX: This now calls App.js setScreen which will update StickyNav
        setScreen(targetScreen);
        setActiveDate(date);
        console.log("🎯 Called setScreen with:", targetScreen);
    };

    // Add this useEffect to debug screen changes
    React.useEffect(() => {
        console.log("🎯 today_pg_PL screen prop changed to:", screen);
    }, [screen]);

    return (
        <div className="main-dash-container" style={{ maxWidth: 3000, margin: "0 auto", padding: "0 0 0 0" }} data-analytics={MODULE_NAME}>
            <TopHeader
                userId={userId}
                activeDate={activeDate}
                screen={screen}
                refreshKey={refreshKey}
                onNavigate={setScreen}
            />
            <GradientSeparator />

            <div style={{ flex: 1, minWidth: 600 }}>
                <IndexCompareChart userId={userId} activeDate={activeDate} screen={screen} refreshKey={refreshKey} />
            </div>
            <GradientSeparator />

            {screen === "pg_details" ? (
                <DetailsPage
                    date={sessionStorage.getItem("navigationDate")}
                    refreshKey={refreshKey}
                    screen={screen}
                    setScreen={setScreen}
                />
            ) : (
                <>
                    <div style={{ display: "flex", gap: 32 }}>
                        <div style={{ flex: 1, minWidth: 350 }}>
                            <MaxQtyCompare userId={userId} activeDate={activeDate} screen={screen} refreshKey={refreshKey} />
                        </div>
                        <div style={{ flex: 3, minWidth: 500, minHeight: 600, display: "flex", flexDirection: "column" }}>
                            <HtmlCalendarMonth
                                userId={userId}
                                activeDate={activeDate}
                                screen={screen}
                                refreshKey={refreshKey}
                                onNavigate={handleNavigate}
                                tagFilter={globalTagFilter} // <-- Pass tag filter here
                            />
                        </div>
                    </div>
                    <GradientSeparator />
                    <div style={{ display: "flex", gap: 32 }}>
                        <div style={{ flex: 1, minWidth: 600 }}>
                            <CalendarYear userId={userId} activeDate={activeDate} screen={screen} refreshKey={refreshKey} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}